import HeadingAndDesc from 'components/HeadingAndDesc';
import { Button, P, Section, Wrapper } from 'components/base';
import PropTypes from 'prop-types';
import React from 'react';
import { signUpUrl } from 'utils/config';
import { buttons, content, descC, image as imageC, itemC, list as listC, number, root } from './Steps.module.scss';

const Steps = ({ data, theme }) => (
  <>
    <HeadingAndDesc data={{"heading": `${data.heading}`, "desc": `${data.description ? data.description : ''}`}} padding="TopL" theme={theme} />
    <Section padding="BottomL" theme={theme}>
      <Wrapper size="L" className={root}>
        <div className={imageC}>
          <img src={data.image.publicURL} alt={data.heading} />
        </div>
        <div className={content}>
          <ul className={listC}>
            {data.list.map((item, i) => (
              <li key={i}>
                <div className={itemC}>
                  <span className={number}>{i + 1}</span>
                  <h3>{item.heading}</h3>
                </div>
                { item.desc &&  <P className={descC}>{item.desc}</P>}
              </li>
            ))}
          </ul>
          <div className={buttons}>
            <Button href={signUpUrl} text={data.ctaText ? data.ctaText : '立即註冊試用'} type="secondary" size="L" />
            <a href={data.link} target="_blank" rel="noopener noreferrer" className="text-link">教學文章</a>
          </div>
        </div>
      </Wrapper>
    </Section>
  </>
);

Steps.propTypes = {
  data: PropTypes.object,
  theme: PropTypes.string,
}

Steps.defaultProps = {
  theme: null,
}

export default Steps;